import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getNotificationDestinations } from 'Shared/actions/notifications';
import Spinner from 'Shared/components/Spinner';

import UserNotificationsBrowser from './UserNotificationsBrowser/UserNotificationsBrowser';
import UserNotificationsEmail from './UserNotificationsEmail/UserNotificationsEmail';
import UserNotificationsChat from './UserNotificationsChat/UserNotificationsChat';
import UserNotificationsChatDisconnected from './UserNotificationsChat/UserNotificationsChatDisconnected';
import UserNotificationNotDisturb from './UserNotificationNotDisturb/UserNotificationNotDisturb';
import './UserNotifications.scss';

const UserNotifications = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { featureFlagBrowserNotification } = useFlags();

  const hasSlackConnected = useSelector(state =>
    state.notification_destinations.find(
      ({ slug, connected, has_authorization }) => slug === 'slack' && connected && has_authorization
    )
  );

  const hasMicrosoftTeamsConnected = useSelector(state =>
    state.notification_destinations.find(
      ({ slug, connected, has_authorization }) => slug === 'microsoft_teams' && connected && has_authorization
    )
  );

  const hasGoogleChatConnected = useSelector(state =>
    state.notification_destinations.find(
      ({ slug, connected, has_authorization }) => slug === 'google_chat' && connected && has_authorization
    )
  );

  const hasMetaWorkplaceConnected = useSelector(state =>
    state.notification_destinations.find(
      ({ slug, connected, has_authorization }) => slug === 'meta_workplace' && connected && has_authorization
    )
  );

  useEffect(() => {
    async function getDestinations() {
      setIsLoading(true);
      await dispatch(getNotificationDestinations());
      setIsLoading(false);
    }
    getDestinations();
  }, []);

  return (
    <div className="UserNotifications">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="UserNotifications__section">
            <UserNotificationsEmail />
          </div>
          {featureFlagBrowserNotification && (
            <div className="UserNotifications__section">
              <UserNotificationsBrowser />
            </div>
          )}
          <UserNotificationsChatDisconnected />
          {hasSlackConnected && (
            <div className="UserNotifications__section">
              <UserNotificationsChat type="slack" />
            </div>
          )}
          {hasMicrosoftTeamsConnected && (
            <div className="UserNotifications__section">
              <UserNotificationsChat type="microsoft_teams" />
            </div>
          )}
          {hasGoogleChatConnected && (
            <div className="UserNotifications__section">
              <UserNotificationsChat type="google_chat" />
            </div>
          )}
          {hasMetaWorkplaceConnected && (
            <div className="UserNotifications__section">
              <UserNotificationsChat type="meta_workplace" />
            </div>
          )}
          <div className="UserNotifications__section">
            <UserNotificationNotDisturb />
          </div>
        </>
      )}
    </div>
  );
};

export default UserNotifications;
